export default __webpack_public_path__ + "static/media/instagram-icon.3336bd71.svg";